<template>
  <main class="quick-config-page">
    <section class="config-grid">
      <div class="soft-card info-card">
        <div class="info-label">API Key</div>
        <div class="info-value">{{ config.apiKey || '-' }}</div>
        <el-button size="small" type="text" icon="el-icon-document-copy" @click="copyText(config.apiKey)">复制</el-button>
      </div>
      <div class="soft-card info-card highlight">
        <div class="info-label">OpenAI 协议地址 <span class="protocol-badge">推荐</span></div>
        <div class="info-value">{{ config.openAiUrl || '-' }}</div>
        <el-button size="small" type="text" icon="el-icon-document-copy" @click="copyText(config.openAiUrl)">复制</el-button>
      </div>
      <div class="soft-card info-card">
        <div class="info-label">Anthropic 协议地址 <span class="protocol-badge badge-app">仅 Claude Code</span></div>
        <div class="info-value">{{ config.anthropicUrl || '-' }}</div>
        <el-button size="small" type="text" icon="el-icon-document-copy" @click="copyText(config.anthropicUrl)">复制</el-button>
      </div>
    </section>

    <section class="soft-card tools-card">
      <div class="section-title compact">
        <h2>常用工具</h2>
        <p class="section-hint">统一推荐使用 OpenAI 协议接入；仅 Claude Code 因原生支持使用 Anthropic 协议。</p>
      </div>
      <div class="tool-grid">
        <button
          v-for="tool in tools"
          :key="tool.name"
          type="button"
          class="tool-card"
          :class="{ active: selectedTool && selectedTool.name === tool.name }"
          @click="selectedTool = tool"
        >
          <span class="tool-icon" :style="{ background: tool.gradient }">
            <img v-if="tool.icon" :src="tool.icon" :alt="tool.name" @error="tool.icon = ''">
            <span v-else>{{ tool.abbr }}</span>
          </span>
          <span class="tool-meta">
            <strong>{{ tool.name }}</strong>
            <small>{{ tool.summary }}</small>
          </span>
          <span class="protocol-tag" :class="tool.protocol">{{ tool.protocol === 'OPENAI' ? 'OpenAI' : 'Anthropic' }}</span>
        </button>
      </div>

      <div v-if="selectedTool" class="tool-detail">
        <div class="tool-detail-head">
          <span class="tool-icon large" :style="{ background: selectedTool.gradient }">
            <img v-if="selectedTool.icon" :src="selectedTool.icon" :alt="selectedTool.name" @error="selectedTool.icon = ''">
            <span v-else>{{ selectedTool.abbr }}</span>
          </span>
          <div>
            <h3>{{ selectedTool.name }}</h3>
            <p>{{ selectedTool.description }}</p>
          </div>
        </div>
        <div class="section-block">
          <div class="block-title-row">
            <div class="block-title">配置文件位置</div>
            <el-button size="small" type="text" icon="el-icon-document-copy" @click="copyText(selectedTool.command)">复制</el-button>
          </div>
          <div class="code-block">{{ selectedTool.command }}</div>
        </div>
        <div class="section-block">
          <div class="block-title-row">
            <div class="block-title">使用说明</div>
            <el-button size="small" type="text" icon="el-icon-document-copy" @click="copyText(selectedTool.usage)">复制</el-button>
          </div>
          <div class="code-block">{{ selectedTool.usage }}</div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'QuickConfigPage',
  data() {
    return {
      config: {
        apiKey: '',
        anthropicBaseUrl: '',
        anthropicUrl: '',
        openAiUrl: ''
      },
      selectedTool: null
    }
  },
  computed: {
    tools() {
      return [
        {
          name: 'OpenCode',
          abbr: 'OC',
          protocol: 'OPENAI',
          summary: '开源 AI 编程助手 CLI',
          icon: require('@/assets/tools/opencode.svg'),
          gradient: 'linear-gradient(135deg, #6366f1, #06b6d4)',
          description: 'OpenCode 是开源的终端 AI 编程助手，通过 OpenAI 兼容协议接入当前 AI 网关。',
          command: '全局配置位置：~/.config/opencode/opencode.json\n项目配置位置：./opencode.json 或 .opencode/opencode.json\n\nMac/Linux 创建命令：mkdir -p ~/.config/opencode',
          usage: '将下面内容写入 opencode.json：\n\n' + this.openCodeSettings + '\n\n填写说明：\n- baseURL 使用网关的 OpenAI 协议地址（不含 /v1/chat/completions）。\n- apiKey 使用当前页面顶部的 API Key。\n- model 和 small_model 中的模型 ID 必须是网关里已分配给当前账号的模型名称。\n- 保存后重启 OpenCode 即可生效。'
        },
        {
          name: 'WorkBuddy',
          abbr: 'WB',
          protocol: 'OPENAI',
          summary: '腾讯桌面 AI 智能体',
          icon: require('@/assets/tools/workbuddy_logo.svg'),
          gradient: 'linear-gradient(135deg, #0ea5e9, #6366f1)',
          description: 'WorkBuddy 通过配置文件 models.json 接入自定义模型，使用 OpenAI 兼容协议把请求转发到当前 AI 网关。',
          command: '在用户目录下创建 .workbuddy 文件夹并新建 models.json：\nMac/Linux：~/.workbuddy/models.json\nWindows：C:\\Users\\你的用户名\\.workbuddy\\models.json\n\n创建文件夹命令：\nMac/Linux：mkdir -p ~/.workbuddy\nWindows：mkdir %USERPROFILE%\\.workbuddy',
          usage: '将下面内容写入 models.json：\n\n' + this.workbuddySettings + '\n\n填写说明：\n- url 使用网关的 OpenAI 协议地址（完整的 /v1/chat/completions）。\n- apiKey 使用当前页面顶部的 API Key。\n- id 必须填写网关里已分配给当前账号的模型名称，这里以 deepseek-v4-flash-0731 为例。\n- 如需隐藏内置模型，可加上 "availableModels": ["deepseek-v4-flash-0731"]。\n- 保存后必须重启 WorkBuddy 才能生效，然后在模型列表里选 deepseek-v4-flash-0731。'
        },
        {
          name: 'Trae',
          abbr: 'T',
          protocol: 'OPENAI',
          summary: 'AI 原生 IDE',
          icon: require('@/assets/tools/trae.png'),
          gradient: 'linear-gradient(135deg, #2563eb, #7c3aed)',
          description: '在 Trae 中新增一个 OpenAI 兼容模型供应商，然后把请求转发到当前 AI 网关。',
          command: '1. 打开 Trae\n2. 点击右下角模型设置入口\n3. 进入 AI / Models 或模型配置页面\n4. 选择添加自定义模型供应商\n5. Provider 类型选择 OpenAI / OpenAI 兼容\n6. 按下方配置项填写后保存',
          usage: 'Provider Name：AI Gateway\nBase URL：' + this.openAiBaseUrl + '\nAPI Key：' + this.config.apiKey + '\nModel ID：deepseek-v4-flash-0731\nDisplay Name：deepseek-v4-flash-0731\n\n填写说明：\n- Base URL 使用 OpenAI 基础地址，不要填写完整的 /v1/chat/completions。\n- API Key 使用当前页面顶部的 API Key。\n- Model ID 必须填写网关里已分配给当前账号的模型名称，这里以 deepseek-v4-flash-0731 为例。\n- 保存后，在 Trae 的模型选择列表里选 deepseek-v4-flash-0731，就会通过 AI 网关的 OpenAI 协议调用。'
        },
        {
          name: 'DeepSeek Harness',
          abbr: 'DSH',
          protocol: 'OPENAI',
          summary: 'DeepSeek 官方 WEB 工具',
          icon: '',
          gradient: 'linear-gradient(135deg, #4f46e5, #9333ea)',
          description: 'DeepSeek Harness 是 DeepSeek 官方 WEB 工具，通过 OpenAI 兼容协议接入当前 AI 网关。',
          command: '1. 打开 DeepSeek Harness\n2. 进入设置 → 模型\n3. 点击「添加自定义提供方」（不是内置提供方）\n4. 填写 Provider ID（小写且永久）、显示名称、API 地址、API 协议、API 密钥\n5. 在模型目录添加模型并设为默认',
          usage: '提供方配置：\n- Provider ID：小写且永久，如 hyp-one-llm\n- API 地址：' + this.openAiBaseUrl + '（已含 /v1，不要重复加 /v1）\n- API 协议：openai-completions（对应 OpenAI Chat Completions）\n- API 密钥：' + this.config.apiKey + '\n- 模型 ID：网关里已分配给当前账号的模型名，如 deepseek-v4-flash-0731\n\n若网关拒绝每一个请求：$DSH_HOME/settings.yaml 中给该提供方加 compat 开关，保存后新开会话：\n\n' + this.dshSettingsYaml + '\n\n说明：supportsDeveloperRole: false 让系统提示词走 system 角色（默认推理模型会发 developer 角色，多数网关拒绝）；maxTokensField: max_tokens 让输出上限写 max_tokens（DSH 默认写 max_completion_tokens）。如模型默认思考且需可关闭，可再加 compat.thinkingFormat: deepseek。'
        },
        {
          name: 'Claude Code',
          abbr: 'CC',
          protocol: 'ANTHROPIC',
          summary: 'Claude 官方命令行工具',
          icon: require('@/assets/tools/claude.png'),
          gradient: 'linear-gradient(135deg, #111827, #4b5563)',
          description: 'Claude Code 原生仅支持 Anthropic 协议，故使用该协议接入网关；默认模型档位映射到 deepseek-v4-flash-0731。',
          command: '默认安装位置：~/.claude/settings.json\nWindows 默认位置：C:\\Users\\你的用户名\\.claude\\settings.json',
          usage: '将下面内容写入 settings.json：\n\n' + this.claudeCodeSettings + '\n\n保存后重启 Claude Code，新会话会通过网关调用 Anthropic 协议地址。'
        }
      ]
    },
    claudeCodeSettings() {
      return JSON.stringify({
        env: {
          ANTHROPIC_AUTH_TOKEN: this.config.apiKey,
          ANTHROPIC_BASE_URL: this.config.anthropicBaseUrl,
          API_TIMEOUT_MS: '3000000',
          CLAUDE_CODE_DISABLE_NONESSENTIAL_TRAFFIC: '1',
          ANTHROPIC_DEFAULT_HAIKU_MODEL: 'deepseek-v4-flash-0731',
          ANTHROPIC_DEFAULT_SONNET_MODEL: 'deepseek-v4-flash-0731',
          ANTHROPIC_DEFAULT_OPUS_MODEL: 'deepseek-v4-flash-0731',
          CLAUDE_DEFAULT_MODEL: 'SONNET'
        }
      }, null, 2)
    },
    openAiBaseUrl() {
      return (this.config.openAiUrl || '').replace(/\/chat\/completions$/, '')
    },
    workbuddySettings() {
      return JSON.stringify({
        models: [
          {
            id: 'deepseek-v4-flash-0731',
            name: 'deepseek-v4-flash-0731',
            vendor: 'AI Gateway',
            apiKey: this.config.apiKey,
            maxInputTokens: 128000,
            maxOutputTokens: 8192,
            url: this.config.openAiUrl,
            supportsToolCall: true,
            supportsImages: true
          }
        ]
      }, null, 2)
    },
    openCodeSettings() {
      return JSON.stringify({
        $schema: 'https://opencode.ai/config.json',
        permission: {
          edit: 'allow',
          bash: 'allow',
          webfetch: 'allow'
        },
        provider: {
          'axonhub-openai': {
            npm: '@ai-sdk/openai-compatible',
            name: 'AxonHub OpenAI',
            options: {
              baseURL: this.openAiBaseUrl,
              apiKey: this.config.apiKey
            },
            models: {
              'deepseek-v4-flash-0731': {
                id: 'deepseek-v4-flash-0731',
                name: 'DeepSeek V4 Flash'
              }
            }
          }
        },
        model: 'axonhub-openai/deepseek-v4-flash-0731',
        small_model: 'axonhub-openai/deepseek-v4-flash-0731'
      }, null, 2)
    },
    dshSettingsYaml() {
      return [
        'llm-pi-ai:',
        '  providers:',
        '    hyp-one-llm:',
        '      api: openai-completions',
        '      baseURL: ' + this.openAiBaseUrl,
        '      compat:',
        '        supportsDeveloperRole: false',
        '        maxTokensField: max_tokens',
        '      models:',
        '        - id: deepseek-v4-flash-0731'
      ].join('\n')
    }
  },
  async mounted() {
    await this.fetchConfig()
  },
  methods: {
    async fetchConfig() {
      try {
        this.config = await this.$http.get('/admin/quick-config')
        this.selectedTool = this.tools[0]
      } catch {
        this.$message.error('加载快速配置失败')
      }
    },
    copyText(text) {
      if (!text) return
      const ta = document.createElement('textarea')
      ta.value = text
      ta.style.position = 'fixed'
      ta.style.opacity = '0'
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
        this.$message.success('已复制')
      } catch {
        this.$message.warning('复制失败')
      }
      document.body.removeChild(ta)
    }
  }
}
</script>

<style scoped>
.quick-config-page {
  padding: 18px 24px 76px;
}

.config-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.info-card {
  padding: 20px;
  border-radius: var(--radius);
  min-width: 0;
}

.info-card.highlight {
  border-color: rgba(50, 200, 245, 0.4);
  box-shadow: 0 0 0 1px rgba(50, 200, 245, 0.15) inset;
}

.protocol-badge {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  vertical-align: 1px;
  background: rgba(52, 201, 143, 0.16);
  color: var(--green);
}

.protocol-badge.badge-app {
  background: rgba(244, 183, 79, 0.16);
  color: var(--amber);
}

.info-label {
  font-size: 13px;
  color: var(--muted);
  margin-bottom: 10px;
}

.info-value {
  min-height: 44px;
  font-size: 14px;
  line-height: 1.5;
  font-family: 'SF Mono', 'Fira Code', monospace;
  font-weight: 700;
  color: var(--text);
  word-break: break-all;
}

.tools-card {
  margin-top: 20px;
  padding: 20px;
  border-radius: var(--radius);
}

.section-title.compact h2 {
  margin: 0;
  font-size: 18px;
  color: var(--text);
}

.section-hint {
  margin: 6px 0 0;
  font-size: 12px;
  color: var(--muted-2);
}

.tool-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
  margin-top: 16px;
}

.tool-card {
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: rgba(255, 255, 255, 0.045);
  padding: 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;
}

.tool-card:hover,
.tool-card.active {
  border-color: rgba(50, 200, 245, 0.46);
  box-shadow: 0 12px 28px rgba(50, 150, 245, 0.18);
  transform: translateY(-1px);
}

.tool-icon {
  width: 42px;
  height: 42px;
  border-radius: 13px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  overflow: hidden;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.24);
}

.tool-icon.large {
  width: 52px;
  height: 52px;
  border-radius: 16px;
}

.tool-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.tool-meta {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.tool-meta strong {
  font-size: 15px;
  color: var(--text);
}

.tool-meta small {
  font-size: 12px;
  color: var(--muted-2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.protocol-tag {
  flex: none;
  margin-left: auto;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  align-self: flex-start;
  background: rgba(50, 200, 245, 0.14);
  color: #32c8f5;
}

.protocol-tag.ANTHROPIC {
  background: rgba(244, 183, 79, 0.14);
  color: var(--amber);
}

.tool-detail {
  margin-top: 22px;
  border-top: 1px solid var(--line);
  padding-top: 20px;
}

.tool-detail-head {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
}

.tool-detail h3 {
  margin: 0 0 6px;
  font-size: 20px;
  color: var(--text);
}

.tool-detail p {
  margin: 0;
  color: var(--muted);
  font-size: 14px;
}

.section-block {
  margin-top: 16px;
}

.block-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.block-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--muted);
}

.code-block {
  background: rgba(0, 0, 0, 0.22);
  border: 1px solid var(--line-soft);
  border-radius: var(--radius);
  padding: 14px 16px;
  font-family: 'SF Mono', 'Fira Code', monospace;
  font-size: 13px;
  line-height: 1.6;
  white-space: pre-wrap;
  color: #dbe8fb;
}

@media (max-width: 1100px) {
  .config-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 760px) {
  .quick-config-page {
    padding: 12px 12px 28px;
  }
  .tools-card {
    padding: 14px;
  }
}
</style>
